import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { AppModule } from './app/app.module';

registerLocaleData(localeEs);

function addNonBlockingAttribute() {
  const trustScripts = ["main", "runtime", "polyfills", "styles", "vendor"];
  Array.from(document.scripts)
    .filter(script => trustScripts.some(scriptName => script.src.includes(scriptName)))
    .forEach(script => script.setAttribute("data-cookieconsent", "ignore"));
}
addNonBlockingAttribute();

platformBrowserDynamic()
  .bootstrapModule(AppModule, { ngZoneEventCoalescing: true })
  .catch(err => console.error(err));
